import React  from 'react';
import './toggleSwitch.scss';
let input;
const toggleSwitch = ({title, callback, defaultValue, disabled}) => {
    return (
        <label className="boolean-control control-switch no-scale" style={{cursor: 'pointer'}}>
            <input checked={defaultValue} disabled={disabled} ref={node => input = node}  id='toggle'   type="checkbox" className="input-switch" data-indeterminate="false" onChange={() => callback(input)}/>
            <span className="label label-switch">{title}</span>
            <svg className="symbol-switch" width="50" height="28" viewBox="0 0 50 28">
                <g>
                    <path d="M14 24.5C7.659 24.5 2.5 19.341 2.5 13S7.659 1.5 14 1.5h21c6.341 0 11.5 5.159 11.5 11.5S41.341 24.5 35 24.5H14" className="st1"></path>
                    <path d="M35 2c6.065 0 11 4.935 11 11s-4.935 11-11 11H14C7.935 24 3 19.065 3 13S7.935 2 14 2h21m0-1H14C7.373 1 2 6.373 2 13s5.373 12 12 12h21c6.627 0 12-5.373 12-12S41.627 1 35 1" className="st2"></path> 
                    <g className="switch-thumb-regular"> 
                        <path d="M25 13.5C25 19.299 20.075 24 14 24S3 19.299 3 13.5v-1C3 6.701 7.925 2 14 2s11 4.701 11 10.5v1" className="switch-thumb-circle"></path>
                        <path d="M10.008 13.344c.031.205.145.4.334.534l2.781 1.961a.886.886 0 0 0 1.191-.158l3.512-4.385a.778.778 0 0 0-.164-1.13.883.883 0 0 0-1.195.154l-3 3.744-2.103-1.48a.885.885 0 0 0-1.194.163.778.778 0 0 0-.162.597" className="switch-thumb-check"></path>
                        <path d="M19 13c0 .552-.497 1-1.111 1h-7.778C9.498 14 9 13.552 9 13s.498-1 1.111-1h7.778c.614 0 1.111.448 1.111 1" className="switch-thumb-minus"></path>
                    </g>
                    <g className="switch-thumb-selected">
                        <path d="M46 13.5C46 19.299 41.075 24 35 24s-11-4.701-11-10.5v-1C24 6.701 28.925 2 35 2s11 4.701 11 10.5v1" className="switch-thumb-circle"></path>
                        <path d="M31.008 13.344c.031.205.145.4.334.534l2.781 1.961a.886.886 0 0 0 1.191-.158l3.512-4.385a.778.778 0 0 0-.164-1.13.883.883 0 0 0-1.195.154l-3 3.744-2.103-1.48a.885.885 0 0 0-1.194.163.778.778 0 0 0-.162.597" className="switch-thumb-check"></path>
                        <path d="M40 13c0 .552-.497 1-1.111 1h-7.778C30.498 14 30 13.552 30 13s.498-1 1.111-1h7.778c.614 0 1.111.448 1.111 1" className="switch-thumb-minus"></path>
                    </g>
                </g>
            </svg>
        </label>
    )
}

export default toggleSwitch;


// WEBPACK FOOTER //
// ./src/settings/Containers/gdUnitControlPanel/modules/settings/toggleSwitch.js